/*
 * strova cart
 * Warenkorb ueber die Shopify Cart-AJAX-API, Neurendern ueber die Section-Rendering-API.
 * Kein eigener Warenkorbzustand, keine Preisberechnung im Frontend.
 * Es werden keine Commerce-Ereignisse gefeuert — Shopify erzeugt sie aus denselben Aufrufen.
 */
(function () {
  'use strict';

  var strova = (window.strova = window.strova || {});
  var DRAWER_SECTION = 'strova-cart-drawer';

  function drawer() {
    return document.querySelector('[data-st-cart-drawer]');
  }

  var layer = null;

  function announce(open) {
    document.dispatchEvent(new CustomEvent('strova:drawer', { detail: { open: open } }));
  }

  function openDrawer(opener) {
    var node = drawer();
    if (!node) return;
    layer = strova.openLayer(node, 'is-open', opener);
    announce(true);
  }

  function closeDrawer() {
    if (!layer) return;
    strova.closeLayer(layer);
    layer = null;
    announce(false);
  }

  strova.openCart = openDrawer;

  function setLoading(state) {
    var node = drawer();
    if (node) node.classList.toggle('is-loading', state);
  }

  function refresh() {
    return fetch(window.strova.routes.root + '?sections=' + DRAWER_SECTION, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var markup = sections[DRAWER_SECTION];
        if (!markup) return;
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = parsed.querySelector('[data-st-cart-drawer]');
        var current = drawer();
        if (!fresh || !current) return;

        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        current.hidden = !wasOpen;
        if (wasOpen) current.classList.add('is-open');
        bindDrawer();
        return fetch(window.strova.routes.cart + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            document.querySelectorAll('[data-st-cart-count]').forEach(function (node) {
              node.textContent = node.tagName === 'SPAN' && node.closest('.st-drawer__title') ? '(' + cart.item_count + ')' : cart.item_count;
            });
          });
      });
  }

  strova.refreshCart = refresh;

  function request(url, body) {
    setLoading(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        return refresh().then(function () {
          return data;
        });
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function changeLine(key, quantity) {
    return request(window.strova.routes.cart_change, { id: key, quantity: quantity });
  }

  function addVariant(id, quantity, properties) {
    var item = { id: Number(id), quantity: quantity || 1 };
    if (properties) item.properties = properties;
    return request(window.strova.routes.cart_add, { items: [item] });
  }

  strova.addVariant = addVariant;

  function bindDrawer() {
    var node = drawer();
    if (!node) return;

    node.querySelectorAll('[data-st-cart-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    node.querySelectorAll('[data-st-line-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-st-line-qty');
        var quantity = parseInt(button.getAttribute('data-st-qty-value'), 10);
        changeLine(key, Math.max(0, quantity));
      });
    });

    node.querySelectorAll('[data-st-line-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        changeLine(button.getAttribute('data-st-line-remove'), 0);
      });
    });

    node.querySelectorAll('[data-st-quick-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.disabled = true;
        addVariant(button.getAttribute('data-st-quick-add'), 1).finally(function () {
          button.disabled = false;
        });
      });
    });
  }

  function bindGlobal() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-st-cart-open]');
      if (opener && drawer()) {
        event.preventDefault();
        openDrawer(opener);
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-st-product-form]');
      if (!form) return;
      event.preventDefault();

      var submit = form.querySelector('[data-st-add-to-cart]');
      var errorNode = form.querySelector('[data-st-form-error]');
      if (submit) submit.disabled = true;
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
      setLoading(true);

      fetch(window.strova.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          return refresh();
        })
        .then(function () {
          openDrawer(submit);
        })
        .catch(function (error) {
          if (errorNode) {
            errorNode.textContent = (error && error.description) || 'Der Artikel konnte nicht hinzugefügt werden.';
            errorNode.hidden = false;
          }
        })
        .finally(function () {
          if (submit) submit.disabled = false;
          setLoading(false);
        });
    });
  }

  function boot() {
    bindDrawer();
    bindGlobal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-st-cart-drawer]')) bindDrawer();
  });
})();
